import TextField from "@material-ui/core/TextField";
import React, { useState } from "react";
import { InputAdornment } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import { Visibility, VisibilityOff } from "@material-ui/icons";

const FormikPasswordField = ({ form, field, error, parse, ...rest }) => {
  const [showPassword, setShowPassword] = useState(false);

  console.log("Password field", field, rest);
  error = "";
  if (form.errors[field.name] && form.touched[field.name]) {
    console.log("Error", form.errors, form.touched);
    error = form.errors[field.name];
  }

  const _onChange = (e) => {
    let value = e.target.value;
    if (parse) {
      value = parse(value);
    }
    form.setFieldValue(field.name, value);
  };

  return (
    <TextField
      margin="normal"
      fullWidth={true}
      error={!!error}
      helperText={error}
      {...field}
      onChange={_onChange}
      {...rest}
      type={showPassword ? "text" : "password"}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={() => setShowPassword(!showPassword)}
              edge="end"
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default FormikPasswordField;
